import { OPENED } from "commom/consts/evaluations/const-status";
import { useEvaluationContext } from "commom/contexts/useEvaluationContext";
import EvaluationForm from "components/forms/evaluation-form";
import { useEffect } from "react";
import { Container } from "react-bootstrap";
import { useParams, Navigate, useNavigate } from "react-router-dom";
import useRequestState from "hooks/useRequestState";
import useEventId from 'hooks/useEventId';
import { toast } from "react-toastify";
import evaluationClient from "services/client/evaluation-client";

/**
 * Page for evaluating a project.
 * @returns The page with evaluate form
 */
const Evaluate = () => {

    const { projectCode, uuidStr } = useParams();

    const navigate = useNavigate();

    const { getProjectByCode, saveEvaluation, evaluationGrades, sheets, getEvaluatorSheets, evaluationSheet, getEvaluationCriteria, criteria } = useEvaluationContext();

    const project = getProjectByCode(projectCode);

    const projectDisplay = (project.box && `${project.box}`) || project.code

    const {
        isLoading,
        setIsLoading
    } = useRequestState({ isLoading: true });

    useEffect(() => {
        if (!project) {
            toast.error("Projeto não encontrado! Por favor, selecione novamente.");
        }
    }, []);

    const sheet = sheets.find((sheet) => sheet.uuid === uuidStr);

    const canEdit = sheet?.can_edit;

    const eventId = useEventId()

    useEffect(() => {

        if (sheet && sheet.sheet_event) {
            setIsLoading(true);
            getEvaluationCriteria(sheet.sheet_event)
                .catch(err => {
                    console.log("Fail to get evaluation criteria - ", err);
                    toast.error('Não foi possível carregar os critérios de avaliação informações da sua ficha. Por favor tente novamente ou entre em contato com alguém da equipe.');
                })
                .finally(() => {
                    setIsLoading(false);
                });
        } else {
            // Se não tem sheet, também para de carregar
            setIsLoading(false);
        }
    }, [sheet]);

    const onSuccessSubmit = async evaluationData => {

        try {            
            await evaluationClient.sendEvaluationGrades(uuidStr, project.id, evaluationData);

            await getEvaluatorSheets(eventId, evaluationSheet.evaluator.uuid);
            
            saveEvaluation({
                [project.code]: {
                    ...evaluationData
                }
            }); //Save the evaluation in the context state.

            toast.success(`Você avaliou com sucesso o projeto ${projectDisplay}.`);

            navigate(`/avaliacao/${eventId}/${uuidStr}/menu`, { replace: true }); //Go back to the menu.
        }
        catch (err) {
            console.error(err);
            toast.error("Ops... Ocorreu um erro ao processar as notas e comentários. Por favor, verifique o formulário ou entre em contato com a equipe.");
        }
    }

    if (!project) {
        return <Navigate
            to={`/avaliacao/${eventId}/${uuidStr}/menu`}
            replace={true}
        />
    }

    const getFormDefaultValues = () => {
        if (!(projectCode in evaluationGrades)) {
            return {}
        }

        return evaluationGrades[projectCode];
    }

    

    const criteriaFields = criteria.map((item) => `grade_${item.id}`);
    criteriaFields.push("comments")
    return (
        <Container as="section">

            {!isLoading ?
            
                <EvaluationForm
                    sheet={sheet}
                    criteria={criteria}
                    project={project}
                    onSuccessSubmit={onSuccessSubmit}
                    canEdit={canEdit}
                    disabledFields={
                        canEdit ? [] : criteriaFields
                    }
                    defaultValues={{
                        ...getFormDefaultValues()
                    }}
                />
                :
                <h1 className="smilage">
                    Aguarde! Estamos preparando sua ficha de avaliação.
                </h1>
            }
        </Container>
    )
}

export default Evaluate;
